/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/multiples.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/
import ConditionsEvo from '../../logic/condition_evo';


class LpMultiples {
  constructor() {
    this.multiples = {};
  }

  addMultiple(p, m) {
    if (typeof (m) === 'object') ConditionsEvo.setupMultipleWatchers(m, p);

    ConditionsEvo.multipleChangeReduce(p, m);

    if (!m || m.length === 0) delete this.multiples[p];
    else this.multiples[p] = m;
  }

  exists(id) {
    return !!this.multiples[id];
  }

  getMultiple(id) {
    return this.multiples[id];
  }
}

export default LpMultiples;



// WEBPACK FOOTER //
// ./src/app/indexes/multiples.js